import { gql } from '@apollo/client';

export const UPDATE_INVOICE = gql`
  mutation UpdateInvoice(
    $invoiceId: String!
    $amount: Float
    $paymentDate: String
    $billingDate: String
    $status: String
    $amountType: String
    $country: String
  ) {
    updateInvoice(
      invoiceId: $invoiceId
      amount: $amount
      paymentDate: $paymentDate
      billingDate: $billingDate
      status: $status
      amountType: $amountType
      country: $country
    ) {
      status
      code
      data
      error
    }
  }
`;
export const VALIDATE_INVOICE = gql`
  mutation ValidateInvoice($invoiceId: String!) {
    validateInvoice(invoiceId: $invoiceId) {
      status
      code
      data
      error
    }
  }
`;
export const DELETE_INVOICE = gql`
  mutation DeleteInvoice($invoiceId: String!) {
    deleteInvoice(invoiceId: $invoiceId) {
      status
      code
      data
      error
    }
  }
`;
export const CREATE_INVOICE = gql`
  mutation CreateInvoice(
    $campaignId: String!
    $file: Upload
    $brandId: String
    $userId: String
    $price: String
    $paymentDate: String
    $billingDate: String
    $currency: String
    $country: String
    $items: [invoiceItemInput!]
  ) {
    createInvoice(
      campaignId: $campaignId
      file: $file
      brandId: $brandId
      userId: $userId
      price: $price
      paymentDate: $paymentDate
      billingDate: $billingDate
      currency: $currency
      country: $country
      items: $items
    ) {
      status
      code
      data
      error
    }
  }
`;
